var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('todos-toggle',{attrs:{"current-user-todos":_vm.currentUserTodos,"is-updating":_vm.isUpdating},on:{"toggle":_vm.onToggle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }